import { useState, useEffect } from "react";
import { buscarInteresses } from "../../../services/buscarInteressesService";
import { formatDate } from "../../../uteis/dateUtils";
import { Interesses } from "../../../interfaces/Interesses";

export const useBuscarInteresses = () => {
  const [interesses, setInteresses] = useState<Partial<Interesses>[]>([]);
  const [isLoading, setIsLoading] = useState(true);

  const buscar = async () => {
    setIsLoading(true);

    const data = await buscarInteresses();

    const dataInteresse = data.map((p: Partial<Interesses>) => {
      return {
        ...p,
        dataIni: formatDate(p.dataIni),
        dataFim: formatDate(p.dataFim),
        situacao:
          p.alugar === 1 && p.trocar === 0
            ? "Alugar"
            : p.alugar === 0 && p.trocar === 1
            ? "Trocar"
            : "Alugar ou trocar",
        status:
          p.status === "ATENDIDO_MC"
            ? "Atendido MC"
            : p.status === "NAO_ATENDIDO"
            ? "Não Atendido"
            : p.status === "AGUARDANDO"
            ? "Aguardando"
            : p.status,
      };
    });

    setInteresses(dataInteresse);
    setIsLoading(false);
  };

  useEffect(() => {
    buscar();
  }, []);

  return { interesses, isLoading, buscar };
};
